import { motion, AnimatePresence } from "framer-motion";
import {
  BarChart3, CalendarDays, ClipboardList, Home, LogOut, MessageSquareHeart, MessagesSquare, PlayCircle, Settings, UserPlus, Users, GraduationCap, X,
} from "lucide-react";

const PARENT = [
  { title: null, items: [["home", "Accueil", Home]] },
  { title: "Plans d’étude", Icon: ClipboardList, items: [["follow", "Voir le suivi des plans"], ["plan", "Proposer un plan d’étude"], ["capture", "Capturer des échéances"]] },
  { title: "Calendrier", Icon: CalendarDays, items: [["week", "Horaire de la semaine"], ["deadlines", "Échéances"]] },
  { title: "Progression", Icon: BarChart3, items: [["report", "Bilan de la semaine"], ["history", "Séances passées"]] },
  { title: "Conversations", Icon: MessagesSquare, items: [["help", "Demandes d’aide"]] },
  { title: "Famille", Icon: UserPlus, items: [["invite", "Inviter un enfant"]] },
];

const STUDENT = [
  { title: null, items: [["home", "Accueil", Home]] },
  { title: "Étudier", Icon: PlayCircle, items: [["start", "Je commence"], ["help", "Je bloque"]] },
  { title: "Mes plans", Icon: ClipboardList, items: [["plans", "Mes plans d’étude"], ["create", "Créer un plan d’étude"], ["capture", "Capturer mes travaux"]] },
  { title: "Mon calendrier", Icon: CalendarDays, items: [["week", "Planifier ma semaine"], ["deadlines", "Mes échéances"]] },
  { title: "Progression", Icon: BarChart3, items: [["report", "Mon bilan"]] },
  { title: "Conversations", Icon: MessagesSquare, items: [["history", "Séances passées"]] },
];

/** Left drawer opened from the chat header: same actions as the chat buttons. */
export const SideMenu = ({ open, parent, canSettings = true, mobileType = false, onPick, onClose }) => {
  const groups = parent ? PARENT : STUDENT;
  const size = mobileType ? "text-[16px]" : "text-[14px]";
  const pick = (id, label) => {
    onClose();
    onPick(id, label);
  };
  const row = `flex w-full items-center gap-3 rounded-xl px-3 py-1.5 text-left text-[#122118] hover:bg-[#F3FCF7] ${size}`;
  return (
    <AnimatePresence>
      {open && (
        <motion.div className="absolute inset-0 z-40 flex" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.nav
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "tween", duration: 0.22 }}
            className="flex h-full w-[82%] max-w-[20rem] flex-col bg-white px-2 pb-3 pt-[max(1rem,env(safe-area-inset-top))] shadow-2xl"
            data-testid="side-menu"
          >
            <div className="flex items-center gap-2 px-3 pb-3">
              {parent ? <Users className="h-5 w-5 text-[#189346]" /> : <GraduationCap className="h-5 w-5 text-[#189346]" />}
              <p className={`flex-1 font-bold text-[#122118] ${mobileType ? "text-[19px]" : "text-[15px]"}`}>{parent ? "Menu Parent" : "Menu Élève"}</p>
              <button type="button" aria-label="Fermer le menu" onClick={onClose} className="rounded-full p-1 text-[#4a5f53]" data-testid="side-menu-close">
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="min-h-0 flex-1 overflow-y-auto">
            {groups.map((group) => (
              <div key={group.title || "top"} className="border-t border-gray-100 py-1">
                {group.title && (
                  <p className="flex items-center gap-2 px-3 pb-0 pt-1 text-[11px] font-bold uppercase tracking-wider text-[#829C8D]">
                    <group.Icon className="h-3.5 w-3.5" /> {group.title}
                  </p>
                )}
                {group.items.map(([id, label, Icon]) => (
                  <button key={id} type="button" className={`${row} ${Icon ? "font-semibold" : "pl-8"}`} onClick={() => pick(id, label)} data-testid={`side-menu-${id}`}>
                    {Icon && <Icon className="h-5 w-5 text-[#4a5f53]" />}
                    {label}
                  </button>
                ))}
              </div>
            ))}
            </div>
            <div className="shrink-0 border-t border-gray-100 pt-1.5">
              {canSettings && (
                <button type="button" className={row} onClick={() => pick("settings", "Paramètres")} data-testid="side-menu-settings">
                  <Settings className="h-5 w-5 text-[#4a5f53]" /> Paramètres
                </button>
              )}
              <button type="button" className={row} onClick={() => pick("feedback", "Envoyer un commentaire")} data-testid="side-menu-feedback">
                <MessageSquareHeart className="h-5 w-5 text-[#4a5f53]" /> Envoyer un commentaire
              </button>
              <button type="button" className={row} onClick={() => pick("end", "Terminer la session")} data-testid="side-menu-end">
                <LogOut className="h-5 w-5 text-[#4a5f53]" /> Terminer la session
              </button>

            </div>
          </motion.nav>
          <button type="button" aria-label="Fermer le menu" className="flex-1 bg-black/35" onClick={onClose} data-testid="side-menu-backdrop" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
